import { useEffect, useState } from 'react';

import { obtieneListadoImagenes } from '../utils/obtieneListadoImagenes';

/**
 * Trae, una sola vez al montar, el listado de fechas con imagen disponible.
 * Recibe la misma configuración que obtieneListadoImagenes.
 */
const useListadoImagenes = (config) => {
    const [listado, setListado] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let vigente = true;

        obtieneListadoImagenes(config)
            .then((fechas) => { if (vigente) setListado(fechas) })
            .catch((e) => { if (vigente) setError(e) })
            .finally(() => { if (vigente) setIsLoading(false) });

        return () => { vigente = false };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { listado, error, isLoading };
};

export default useListadoImagenes;
